
import { initializeApp } from "firebase/app";
import { getFirestore, getDocs, collection, query, onSnapshot, orderBy, doc, updateDoc, addDoc, limit, startAfter, where, writeBatch, collectionGroup } from "firebase/firestore";

// Importa Auth
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyDpb8lLqDSIS5PKCjktpkkaIsn34eAifGc",
    authDomain: "xeroo-phiphi.firebaseapp.com",
    projectId: "xeroo-phiphi",
    storageBucket: "xeroo-phiphi.firebasestorage.app",
    messagingSenderId: "1053902072288",
    appId: "1:1053902072288:web:f66524ee5e4a243b96a385",
    measurementId: "G-D99CGRPBGV"
};


// Inicializa Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);


// Exporta las funciones necesarias
export { db, collection, query, onSnapshot, getDocs, orderBy, doc, updateDoc, addDoc, auth, limit, startAfter, where, writeBatch, storage, collectionGroup, functions };
